var alcohol = [
    {
        'name': 'Øl/cider',
        'percentages': [
            {
                'percentage': 2.5,
            },
            {
                'percentage': 4,
            },
            {
                'percentage': 4.7,
            },
            {
                'percentage': 5.5,
            },
            {
                'percentage': 6.6,
            },
            {
                'percentage': 8,
            },
        ],
        'percentage' : { // default
            'percentage': 4.7,
        },
        'volumes': [
            {
                'name': 'Snitt',
                'volume': 2.5,
            },
            {
                'name': 'Liten flaske/boks',
                'volume': 3.3,
            },
            {
                'name': '0,4 halvliter',
                'volume': 4,
            },
            {
                'name': 'Halvliter',
                'volume': 5,
            },
            {
                'name': 'Stor flaske',
                'volume': 7.5,
            },
        ],
        'volume' : { // default
            'name': '',
            'volume': 5,
        },
        'amount': 1,
    },
    {
        'name': 'Vin/champagne',
        'percentages': [
            {
                'percentage': 10,
            },
            {
                'percentage': 12,
            },
            {
                'percentage': 14,
            },
        ],
        'percentage': { // default
            'percentage': 12,
        },
        'volumes': [
            {
                'name': 'Lite glass',
                'volume': 1.25,
            },
            {
                'name': 'Medium glass',
                'volume': 1.5,
            },
            {
                'name': 'Stort glass',
                'volume': 1.75,
            },
            {
                'name': 'Halvflaske',
                'volume': 3.75,
            },
            {
                'name': 'Flaske',
                'volume': 7.5,
            },
        ],
        'volume': { // default
            'name': '',
            'volume': 1.5,
        },
        'amount': 1,
    },
    {
        'name': 'Sterkvin/likør',
        'percentages': [
            {
                'percentage': 16,
            },
            {
                'percentage': 18,
            },
            {
                'percentage': 20,
            },
        ],
        'percentage': { // default
            'percentage': 18,
        },
        'volumes': [
            {
                'name': 'Lite glass',
                'volume': 0.4,
            },
            {
                'name': 'Miniflaske',
                'volume': 0.5,
            },
            {
                'name': 'Stort glass',
                'volume': 0.75,
            },
            {
                'name': 'Halvflaske',
                'volume': 3.75,
            },
            {
                'name': 'Helflaske',
                'volume': 7.5,
            },
        ],
        'volume': { // default
            'name': '',
            'volume': 0.4,
        },
        'amount': 1,
    },
    {
        'name': 'Sprit/brennevin',
        'percentages': [
            {
                'percentage': 22,
            },
            {
                'percentage': 30,
            },
            {
                'percentage': 40,
            },
            {
                'percentage': 60,
            },
        ],
        'percentage': { // default
            'percentage': 40,
        },
        'volumes': [
            {
                'name': 'Shot/i drink',
                'volume': 0.4,
            },
            {
                'name': 'Miniflaske',
                'volume': 0.5,
            },
            {
                'name': 'Halvflaske',
                'volume': 3.5,
            },
            {
                'name': 'Halvlitersflaske',
                'volume': 5,
            },
            {
                'name': 'Helflaske',
                'volume': 7,
            },
        ],
        'volume': { // default
            'name': '',
            'volume': 0.4,
        },
        'amount': 1,
    },
    {
        'name': 'Egendefinert',
        'percentage': { // default
            'percentage': 40,
        },
        'volume': { // default
            'name': '',
            'volume': 3.5,
        },
    },
];
  
export default alcohol;